<template>
    <div>
        <van-sticky :offset-top="top" style="">
            <div style="font-size: 13px; padding: 10px 0px; box-shadow: 1px 1px 4px #999999; background-color: white">
                <van-row style="line-height: 1">
                    <van-col span="4" style="text-align: center;">
                        <van-field
                                style="padding: 0px;"
                                v-model="left_text"
                                input-align="center"
                                readonly
                        />

                    </van-col>
                    <van-col span="7">
                        <div>
                            <van-field
                                    style="border-radius:3px; padding: 0px 5px; box-shadow: 0px 0px 3px #777777 inset"
                                    v-model="start_time_model"
                                    right-icon="arrow-down"
                                    placeholder="开始时间"
                                    clearable
                                    readonly
                                    @click="setStartTime"
                            />
                        </div>

                    </van-col>
                    <van-col span="2">
                        <van-field
                                style="padding: 0px; text-align: center;"
                                v-model="center_text"
                                input-align="center"
                                readonly
                        />
                    </van-col>
                    <van-col span="7">
                        <van-field
                                style="border-radius:3px; padding: 0px 5px; box-shadow: 0px 0px 3px #777777 inset"
                                v-model="end_time_model"
                                right-icon="arrow-down"
                                placeholder="结束时间"
                                clearable
                                readonly
                                @click="setEndTime"
                        />
                    </van-col>
                    <van-col span="4">
                        <div style="text-align: center; padding-top: 1px">
                            <van-button type="danger" plain size="mini"
                                        style="width: 80%"
                                        v-on:click="clickToSearch"
                            >查询
                            </van-button>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </van-sticky>

        <van-action-sheet v-model="show" style="" :round="false">
            <div style="padding: 10px 0px; background-color: #ffffff;">
                <span style="margin-left: 10px; font-size: 13px">快捷选择</span>
                <van-button style="margin: 0px 5px" plain type="info" size="small"
                            v-on:click="clickToday">今日
                </van-button>
                <van-button style="margin: 0px 5px" plain type="info" size="small"
                            v-on:click="clickYesterday">昨日
                </van-button>
                <van-button style="margin: 0px 5px" plain type="info" size="small"
                            v-on:click="click7days">近7日
                </van-button>
                <van-button style="margin: 0px 5px" plain type="info" size="small"
                            v-on:click="click30days">近30日
                </van-button>
            </div>
            <div>
                <van-tabs title-active-color="#ee0a24" animated swipeable>
                    <van-tab>
                        <div slot="title"><h3>按日期选择</h3></div>
                        <van-datetime-picker
                                :title="time_picker_title"
                                v-model="currentDate"
                                type="date"
                                :min-date="minDate"
                                :max-date="maxDate"
                                @confirm="pickTimes"
                                @cancel="pickCancel"
                        >
                        </van-datetime-picker>
                    </van-tab>
                    <van-tab>
                        <div slot="title"><h3>按月份选择</h3></div>
                        <van-datetime-picker
                                title="请选择月份"
                                v-model="currentMonth"
                                type="year-month"
                                :min-date="minDate"
                                :max-date="maxDate"
                                @confirm="pickMonth"
                                @cancel="pickCancel"
                        >
                        </van-datetime-picker>
                    </van-tab>
                </van-tabs>
            </div>
<!--            <div v-if="isTimeType">-->
<!--                <van-datetime-picker-->
<!--                        :title="time_picker_title"-->
<!--                        v-model="currentDate"-->
<!--                        type="date"-->
<!--                        :min-date="minDate"-->
<!--                        :max-date="maxDate"-->
<!--                        @confirm="pickTimes"-->
<!--                        @cancel="pickCancel"-->
<!--                >-->
<!--                </van-datetime-picker>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--                <van-datetime-picker-->
<!--                        title="请选择月份"-->
<!--                        v-model="currentDate"-->
<!--                        type="year-month"-->
<!--                        :min-date="minDate"-->
<!--                        :max-date="maxDate"-->
<!--                        @confirm="pickMonth"-->
<!--                        @cancel="pickCancel"-->
<!--                >-->
<!--                </van-datetime-picker>-->
<!--            </div>-->
<!--            <div>-->
<!--                <van-button @click="isTimeType = !isTimeType">{{isTimeType? '按月份查询' : '按日期查询'}}</van-button>-->
<!--            </div>-->
        </van-action-sheet>
    </div>
</template>

<script>
    export default {
        name: "Wp_time_pick_model",

        props:{
            dateFormat:{type: String, default: 'yyyy-MM-dd hh:mm:ss'},
            defaultStart:{type: Number, default: -1},//defaultStart===0对应今日数据
            autoSearch:{type: Boolean, default: false},
            top:{type: Number, default: 44},
        },

        data(){
            return{
                time_picker_title: '请选择日期',
                currentDate: new Date(),
                minDate: new Date('2019', '00', '01'),
                maxDate: new Date(),
                // start_time: '',
                // end_time: '',

                pickType: 'start',

                startTime: '',
                endTime: '',
                show: false,

                left_text: "时间",
                center_text: "到",

                //展示的开始时间，用于van-field绑定的model
                start_time_model: '',
                //展示的结束时间，用于van-field绑定的model
                end_time_model: '',

                start_foramt: '',
                end_format: '',

                isTimeType: true,
                currentMonth: new Date(),

            }
        },
        created() {
            if(this.dateFormat === "yyyy-MM-dd hh:mm:ss"){
                this.start_foramt = "yyyy-MM-dd 00:00:00";
                this.end_format = "yyyy-MM-dd hh:mm:ss"
            }else if(this.dateFormat === "yyyy-MM-dd"){
                this.start_foramt = "yyyy-MM-dd";
                this.end_format = "yyyy-MM-dd"
            }

            this.initTimes();
        },

        methods:{
            /**
             * 初始化时间状态
             */
            initTimes() {
                if(this.defaultStart === 0){
                    this.clickToday();
                }else{
                    //近7日
                    this.click7days();
                }

                let times = {
                    start_time: this.startTime,
                    end_time: this.endTime
                };
                this.$emit("pickTimes", times);

                if(this.autoSearch){
                    this.clickToSearch();
                }
            },


            /**
             * 选择今日时间
             */
            clickToday() {
                //获取当日零点的时间
                let date = new Date(new Date().toLocaleDateString());
                this.pickType = 'start';
                this.pickTimes(date);
                this.pickType = 'end';
                this.pickTimes(date);
                //直接查询
                // this.clickToSearch();
            },

            /**
             * 选择昨日时间
             */
            clickYesterday() {
                let date = this.$common.dateAdd('d', -1, new Date(new Date().toLocaleDateString()));
                this.pickType = 'start';
                this.pickTimes(date);
                this.pickType = 'end';
                this.pickTimes(date);
                //直接查询
                // this.clickToSearch();
            },

            click7days(){
                this.setTimesByDays(7);
            },

            click30days(){
                this.setTimesByDays(30);
            },

            setTimesByDays(value){
                let startFix = 1 - value;
                let endFix = 0;

                let startDate = this.$common.dateAdd('d', startFix, new Date());
                let endDate = this.$common.dateAdd('d', endFix, new Date());
                this.startTime = this.$common.dateFmt(this.start_foramt, startDate);
                this.endTime = this.$common.dateFmt(this.end_format, endDate);

                this.start_time_model = this.$common.dateFmt("yyyy-MM-dd", startDate);
                this.end_time_model = this.$common.dateFmt("yyyy-MM-dd", endDate);

                this.show = false;
                //直接查询
                // this.clickToSearch();
            },

            /**
             * 设置开始时间
             */
            setStartTime() {
                this.time_picker_title = "请选择开始日期";
                this.currentDate = new Date(this.$common.dateFmt("yyyy/MM/dd", this.$common.stringToDate(this.startTime)));
                this.currentMonth = new Date(this.$common.dateFmt("yyyy/MM/dd", this.$common.stringToDate(this.startTime)));
                this.show = true;
                this.pickType = 'start';
            },

            /**
             * 设置结束时间
             */
            setEndTime() {
                this.time_picker_title = "请选择结束日期";
                this.currentDate = new Date(this.$common.dateFmt("yyyy/MM/dd", this.$common.stringToDate(this.endTime)));
                this.currentMonth = new Date(this.$common.dateFmt("yyyy/MM/dd", this.$common.stringToDate(this.endTime)));
                this.show = true;
                this.pickType = 'end';
            },

            /**
             * 选择时间
             * @param value 回调传入的选择的时间
             */
            pickTimes(value) {
                if (this.pickType === 'start') {
                    this.startTime = this.$common.dateFmt(this.start_foramt, value);
                    this.start_time_model = this.$common.dateFmt("yyyy-MM-dd", value);
                    this.show = false;
                } else if (this.pickType === 'end') {
                    let endDate = new Date(value.getTime() + 24 * 60 * 60 * 1000 - 1);
                    this.endTime = this.$common.dateFmt(this.end_format, endDate);
                    this.end_time_model = this.$common.dateFmt("yyyy-MM-dd", endDate);
                    this.show = false;
                }
            },

            pickMonth(value){
                let date = new Date(value);
                let month = date.getMonth();
                let year = date.getFullYear();
                let month_start_date = new Date(year, month, 1);
                let month_end_date = new Date(year, month + 1, 0);

                this.startTime = this.$common.dateFmt(this.start_foramt, month_start_date);
                this.start_time_model = this.$common.dateFmt("yyyy-MM-dd", month_start_date);

                let endDate = new Date(month_end_date.getTime() + 24 * 60 * 60 * 1000 - 1);
                this.endTime = this.$common.dateFmt(this.end_format, endDate);
                this.end_time_model = this.$common.dateFmt("yyyy-MM-dd", endDate);

                this.show = false;

            },

            /**
             * 关闭时间选择器
             */
            pickCancel() {
                this.show = false;
            },

            clickToSearch(){
                let times = {
                    start_time: this.startTime,
                    end_time: this.endTime
                };

                this.$emit("pickTimes", times);
                this.$emit("search");
            }
        }
    }
</script>

<style scoped>

</style>